// ラジオボタンの値で表示が切り替わる要素の処理

function switchHidden (element, value) {
  if (value === 0 || value === '0') {
    element.classList.add('d-none')
  } else {
    element.classList.remove('d-none')
  }
}

document.querySelectorAll('.switch-hidden-by-radio').forEach((el) => {
  const inputName = el.dataset.inputName
  document.querySelectorAll(`input[name="${inputName}"]`).forEach((input) => {
    const inputValue = input.value
    input.addEventListener('change', (e) => {
      switchHidden(el, inputValue)
    })
    if (input.checked) {
      switchHidden(el, inputValue)
    }
  })
})
